"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nearbyResultItemsToMapObjects = exports.getPropertyName = exports.getPropertyPosition = exports.getPlacePosition = exports.getRoute = exports.getSuggestions = exports.getIconClass = exports.getIconBackgroundColor = exports.typeToPinStyle = exports.getFilterResults = void 0;
var GoogleMapDirectionSaga_1 = require("@/pages/dbguide/sagas/GoogleMapDirectionSaga");
var NeighbourhoodSaga_1 = require("@/pages/place/sagas/NeighbourhoodSaga");
var NeighbourhoodInfo_1 = require("@/pages/place/states/NeighbourhoodInfo");
var DetailPopNearbyTabType_1 = require("../states/DetailPopNearbyTabType");
var NearbyCommuteMethods_1 = require("../states/NearbyCommuteMethods");
var GoogleMapAutoCompleteSaga_1 = require("@/pages/detail/sagas/GoogleMapAutoCompleteSaga");
var NearbymapState_1 = require("@/pages/common/states/NearbymapState");
var effects_1 = require("redux-saga/effects");
var getPropertyPosition = function (state) { return ({
    lat: state.detail.property.lat,
    lng: state.detail.property.lng,
}); };
exports.getPropertyPosition = getPropertyPosition;
var getPropertyName = function (state) { return state.detail.property.building; };
exports.getPropertyName = getPropertyName;
var nearbyResultItemsToMapObjects = function (results, icon) {
    var propertyCenter, propertyName, mapObjects, propertyPin;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getPropertyPosition)];
            case 1:
                propertyCenter = _a.sent();
                return [4 /*yield*/, effects_1.select(getPropertyName)];
            case 2:
                propertyName = _a.sent();
                mapObjects = results.map(function (it) { return ({
                    icon: icon,
                    kind: NearbymapState_1.NearbymapObjectKind.MARKER,
                    center: it.position,
                    active: true,
                }); });
                propertyPin = {
                    kind: NearbymapState_1.NearbymapObjectKind.PIN,
                    center: propertyCenter,
                    title: propertyName,
                };
                mapObjects.push(propertyPin);
                return [2 /*return*/, mapObjects];
        }
    });
};
exports.nearbyResultItemsToMapObjects = nearbyResultItemsToMapObjects;
var filterToNeighbourhoodType = function (filter) {
    switch (filter) {
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BANK:
            return NeighbourhoodInfo_1.NeighbourhoodItemType.ATM;
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BUS:
            return NeighbourhoodInfo_1.NeighbourhoodItemType.BUS_STATION;
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HOSPITAL:
            return NeighbourhoodInfo_1.NeighbourhoodItemType.PHARMACY;
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RAILWAY:
            return NeighbourhoodInfo_1.NeighbourhoodItemType.SUBWAY_STATION;
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RESTAURANT:
            return NeighbourhoodInfo_1.NeighbourhoodItemType.CAFE;
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL:
            return NeighbourhoodInfo_1.NeighbourhoodItemType.SCHOOL;
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.STORE:
            return NeighbourhoodInfo_1.NeighbourhoodItemType.CONVENIENCE_STORE;
    }
};
var getFilterResults = function (filter, center) {
    return new Promise(function (resolve) {
        var neighbourhoodType = filterToNeighbourhoodType(filter);
        NeighbourhoodSaga_1.loadNearybyType(neighbourhoodType, center, 1000).then(function (results) {
            var items = results.map(function (it) {
                return ({
                    name: it.name,
                    position: {
                        lat: it.geometry.location.lat(),
                        lng: it.geometry.location.lng(),
                    },
                    caption: it.vicinity,
                });
            });
            resolve(items);
        });
    });
};
exports.getFilterResults = getFilterResults;
var typeToPinStyle = function (filterType) {
    switch (filterType) {
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL:
            return 'school';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BUS:
            return 'bus';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BANK:
            return 'atm';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HOSPITAL:
            return 'pharmacy';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RAILWAY:
            return 'subway';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RESTAURANT:
            return 'restaurant';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.STORE:
            return 'store';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.FAVORITES:
            return 'fav';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HISTORY:
            return 'history';
        default:
            return 'pin';
    }
};
exports.typeToPinStyle = typeToPinStyle;
var getIconBackgroundColor = function (filterType) {
    switch (filterType) {
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BANK:
            return '#4971c5';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BUS:
            return '#911eb1';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.FAVORITES:
            return '#085963';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HISTORY:
            return '#085963';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HOSPITAL:
            return '#4971c5';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE:
            return '#085963';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES:
            return '#6b3135';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RAILWAY:
            return '#911eb1';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RESTAURANT:
            return '#bc9408';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL:
            return '#4971c5';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.STORE:
            return '#bc9408';
    }
};
exports.getIconBackgroundColor = getIconBackgroundColor;
var getIconClass = function (filterType) {
    switch (filterType) {
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BANK:
            return 'fas fa-university';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.BUS:
            return 'fas fa-bus';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.FAVORITES:
            return 'fas fa-heart';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HISTORY:
            return 'fas fa-history';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.HOSPITAL:
            return 'fas fa-user-md';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.MYPLACE:
            return 'fas fa-star';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.PROPERTIES:
            return 'fas fa-dollar-sign';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RAILWAY:
            return 'fas fa-subway';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.RESTAURANT:
            return 'fas fa-utensils';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.SCHOOL:
            return 'fas fa-school';
        case DetailPopNearbyTabType_1.DetailPopNearbyTabType.STORE:
            return 'fas fa-store';
    }
};
exports.getIconClass = getIconClass;
var getSuggestions = function (keyword) {
    return GoogleMapAutoCompleteSaga_1.autoComplete(keyword).then(function (results) {
        return results.map(function (it) { return ({
            placeId: it.placeId,
            position: null,
            address: it.address,
            district: it.district,
        }); });
    });
};
exports.getSuggestions = getSuggestions;
var getPlacePosition = function (placeId) {
    return GoogleMapAutoCompleteSaga_1.getPlaceDetail(placeId).then(function (it) { return it.position; });
};
exports.getPlacePosition = getPlacePosition;
var getRoute = function (from, to, method) {
    return new Promise(function (resolve, reject) {
        var getMode = function (method) {
            switch (method) {
                case NearbyCommuteMethods_1.NearbyCommuteMethods.BUS:
                    return 'transit';
                case NearbyCommuteMethods_1.NearbyCommuteMethods.DRIVE:
                    return 'driving';
                case NearbyCommuteMethods_1.NearbyCommuteMethods.WALKING:
                    return 'walking';
            }
        };
        GoogleMapDirectionSaga_1.getPath(from, to, getMode(method)).then(function (_a) {
            var path = _a.path, duration = _a.duration;
            resolve({ path: path, min: Math.round(duration) });
        }).catch(function () {
            reject();
        });
    });
};
exports.getRoute = getRoute;
